import { Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import { isPartnerDashboardUser } from 'lib/auth/dashboardRole'
import AddEditPartner from 'pages/partner/AddEditPartner'

const PartnerSettingsStandalonePage = () => {
  const user = useSelector(state => get(state, 'user.user'))
  const partnerId = user?.partner?._id || user?.partner
  const isPartnerRole = isPartnerDashboardUser(user)

  if (!isPartnerRole) {
    return <Redirect to="/dashboard" />
  }

  if (!partnerId) {
    return <Redirect to="/bookings" />
  }

  return <AddEditPartner currentPartnerId={partnerId} selfService />
}

export default PartnerSettingsStandalonePage
